import { AfterContentInit, AfterViewInit, Component, ElementRef, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { EmployeeStatusesService } from '../employee-statuses.service';
import { Enums } from '../../../../../../configs/Enums';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-current-time',
  templateUrl: './current-time.component.html',
  styleUrls: ['./current-time.component.scss'],
  standalone: false,
})
export class CurrentTimeComponent implements OnInit, AfterContentInit {
  moment = require('moment');
  hoursDate: number;
  minutesDate: number;
  isExistChildBlock: boolean;
  public dateShortFormat = Enums.dates.shortFormat;

  @Input() currentTime;
  @Input() initDate;

  constructor(
    private elementRef: ElementRef,
    private employeeStatusesService: EmployeeStatusesService
  ) {}

  ngOnInit() {
    this.employeeStatusesService.isAddData.subscribe((state: boolean) => {
      if (state) {
        this.setTimePosition();
      }
    });
  }

  ngAfterContentInit() {
    this.setTimePosition();
  }

  setTimePosition() {
    let date = this.moment(this.currentTime).format(this.dateShortFormat);
    let hoursDate = this.moment(this.currentTime).format('HH');
    let minutesDate = this.moment(this.currentTime).format('mm');
    let parent = this.elementRef.nativeElement.parentElement;
    let childBlock = parent.querySelector('div[id="time_' + date + '_' + hoursDate + '"]');

    if (childBlock) {
      this.hoursDate = hoursDate;
      this.minutesDate = minutesDate;
      this.isExistChildBlock = true;
      setTimeout(() => {
        let offsetLeft = childBlock.offsetLeft;
        let s = (childBlock.clientWidth / 60) * minutesDate;
        let elem = this.elementRef.nativeElement.querySelector('.current-time-linear');

        // позиция найденного блока + минуты + 18(сдвиг родительского блока);
        this.elementRef.nativeElement.querySelector('.current-time-linear').style.left = offsetLeft + s + 17 + 'px';
      }, 4);
    }
  }
}
